import React from 'react';

type FloatingCardProps = {
  className?: string;
  children: React.ReactNode;
};

const FloatingCard: React.FC<FloatingCardProps> = ({ className = '', children }) => {
  return (
    <div
      className={`rounded-[24px] border border-primary-100 bg-card text-left shadow-lg backdrop-blur-sm ${className}`}
    >
      {children}
    </div>
  );
};

export default FloatingCard;
